import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Spinner } from '@adsp/ui'
import { AppShell } from '@/components/layout/AppShell'
import { PublicOnly, RequireAuth } from './guards'

const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage'))
const DashboardPage = lazy(() => import('@/features/dashboard/pages/DashboardPage'))
const SitesPage = lazy(() => import('@/features/sites/pages/SitesPage'))
const SiteDetailPage = lazy(() => import('@/features/sites/pages/SiteDetailPage'))
const AdsAccountsPage = lazy(() => import('@/features/adsAccounts/pages/AdsAccountsPage'))
const AdsAccountDetailPage = lazy(() => import('@/features/adsAccounts/pages/AdsAccountDetailPage'))
const ConnectAccountPage = lazy(() => import('@/features/adsAccounts/pages/ConnectAccountPage'))
const OAuthReturnPage = lazy(() => import('@/features/adsAccounts/pages/OAuthReturnPage'))
const BindingsPage = lazy(() => import('@/features/campaignBindings/pages/BindingsPage'))
const BindingDetailPage = lazy(() => import('@/features/campaignBindings/pages/BindingDetailPage'))
const ProposalsPage = lazy(() => import('@/features/proposals/pages/ProposalsPage'))

function PageFallback() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Spinner />
    </div>
  )
}

export function AppRoutes() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicOnly>
              <LoginPage />
            </PublicOnly>
          }
        />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/sites" element={<SitesPage />} />
          <Route path="/sites/:id" element={<SiteDetailPage />} />
          <Route path="/ads-accounts" element={<AdsAccountsPage />} />
          <Route path="/ads-accounts/connect" element={<ConnectAccountPage />} />
          <Route path="/ads-accounts/:id" element={<AdsAccountDetailPage />} />
          {/* OAuth return — the server redirects here (ADS_OAUTH_SUCCESS_REDIRECT)
              with the one-shot handle in the query string. */}
          <Route path="/ads/oauth/return" element={<OAuthReturnPage />} />
          <Route path="/bindings" element={<BindingsPage />} />
          <Route path="/bindings/:id" element={<BindingDetailPage />} />
          <Route path="/proposals" element={<ProposalsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  )
}
